var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHerdRemoved(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#F2F2F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.9827 13.116C27.9827 13.116 26.0276 15.841 24.1408 15.841C23.3845 15.8693 22.6473 15.5996 22.0877 15.09C21.5281 14.5805 21.1909 13.8717 21.1484 13.116C21.1484 11.3003 24.8168 10.2811 27.9827 13.116Z",
    fill: "white",
    stroke: "#1A1A1A",
    strokeWidth: 0.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2903 21.7309C19.0583 22.5647 18.5595 23.2996 17.8704 23.8231C17.1812 24.3467 16.3395 24.6301 15.4741 24.6301C14.6086 24.6301 13.7669 24.3467 13.0777 23.8231C12.3886 23.2996 11.8898 22.5647 11.6578 21.7309L9.36134 13.482C9.24212 13.0568 9.27103 12.6037 9.44332 12.1971C9.61562 11.7905 9.92106 11.4545 10.3095 11.2444C11.8772 10.3334 13.658 9.85352 15.4712 9.85352C17.2844 9.85352 19.0652 10.3334 20.6329 11.2444C21.0215 11.4544 21.327 11.7903 21.4993 12.197C21.6717 12.6036 21.7005 13.0568 21.5811 13.482L19.2903 21.7309Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.60288 14.3538C9.78031 14.0795 10.0239 13.8542 10.3111 13.6986C11.8788 12.7876 13.6597 12.3077 15.4729 12.3077C17.286 12.3077 19.0669 12.7876 20.6346 13.6986C20.9213 13.8541 21.1645 14.079 21.3419 14.3528L21.5856 13.4786C21.8293 12.6006 21.4367 10.7119 20.6374 10.2796C19.0698 9.36855 17.2889 8.88867 15.4757 8.88867C13.6625 8.88867 11.8817 9.36855 10.314 10.2796C9.51376 10.711 9.11933 12.6025 9.36585 13.4786L9.60288 14.3538Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.29 21.7314C19.058 22.5652 18.5592 23.3 17.8701 23.8236C17.1809 24.3471 16.3392 24.6306 15.4737 24.6306C14.6083 24.6306 13.7666 24.3471 13.0774 23.8236C12.3883 23.3 11.8895 22.5652 11.6574 21.7314L9.36103 13.4825C9.11641 12.6064 9.51084 10.7149 10.3092 10.2835C11.8769 9.37246 13.6577 8.89258 15.4709 8.89258C17.2841 8.89258 19.0649 9.37246 20.6326 10.2835C21.4348 10.7158 21.8282 12.6045 21.5808 13.4825L19.29 21.7314Z",
    stroke: "#1A1A1A",
    strokeWidth: 0.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9325 21.8354C12.7366 22.0933 12.6166 22.4007 12.5859 22.7231C12.5553 23.0455 12.6152 23.37 12.759 23.6602C12.9027 23.9504 13.1246 24.1947 13.3997 24.3656C13.6747 24.5366 13.992 24.6273 14.3159 24.6277H16.6294C16.9539 24.6279 17.2719 24.5373 17.5476 24.3661C17.8233 24.195 18.0457 23.9502 18.1896 23.6594C18.3335 23.3685 18.3932 23.0432 18.3619 22.7203C18.3307 22.3973 18.2097 22.0895 18.0127 21.8316L17.9795 21.789C17.6818 21.4093 17.3017 21.1023 16.8679 20.8911C16.4341 20.68 15.9579 20.5703 15.4755 20.5703C14.993 20.5703 14.5169 20.68 14.083 20.8911C13.6492 21.1023 13.2691 21.4093 12.9714 21.789L12.9325 21.8354Z",
    fill: "white",
    stroke: "#1A1A1A",
    strokeWidth: 0.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2422 14.5196C12.2422 14.7781 12.3449 15.026 12.5277 15.2088C12.7105 15.3916 12.9584 15.4943 13.2169 15.4943C13.4754 15.4943 13.7233 15.3916 13.9061 15.2088C14.0889 15.026 14.1916 14.7781 14.1916 14.5196C14.1916 14.2611 14.0889 14.0132 13.9061 13.8304C13.7233 13.6476 13.4754 13.5449 13.2169 13.5449C12.9584 13.5449 12.7105 13.6476 12.5277 13.8304C12.3449 14.0132 12.2422 14.2611 12.2422 14.5196Z",
    fill: "#1A1A1A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6953 14.5196C16.6953 14.7781 16.798 15.026 16.9808 15.2088C17.1636 15.3916 17.4115 15.4943 17.67 15.4943C17.9285 15.4943 18.1764 15.3916 18.3592 15.2088C18.542 15.026 18.6447 14.7781 18.6447 14.5196C18.6447 14.2611 18.542 14.0132 18.3592 13.8304C18.1764 13.6476 17.9285 13.5449 17.67 13.5449C17.4115 13.5449 17.1636 13.6476 16.9808 13.8304C16.798 14.0132 16.6953 14.2611 16.6953 14.5196Z",
    fill: "#1A1A1A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4648 22.3359V23.1286",
    stroke: "#1A1A1A",
    strokeWidth: 0.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3242 22.3359V23.1286",
    stroke: "#1A1A1A",
    strokeWidth: 0.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M2.96484 13.116C2.96484 13.116 4.91993 15.841 6.80674 15.841C7.56298 15.869 8.30003 15.5993 8.85956 15.0898C9.41908 14.5802 9.75641 13.8716 9.7991 13.116C9.7991 11.3003 6.13071 10.2811 2.96484 13.116Z",
    fill: "white",
    stroke: "#1A1A1A",
    strokeWidth: 0.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHerdRemoved);
export default __webpack_public_path__ + "static/media/herd-removed.1f96fea70a80a4d627405c32686edf3c.svg";
export { ForwardRef as ReactComponent };